"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mkAsmLine = exports.mkBreak = exports.mkUseSegment = exports.mkDeclareSegment = exports.mkFilescope = exports.mkLoadPlugin = exports.mkStmtExpr = exports.mkAssign = exports.mkLet = exports.mkCallMacro = exports.mkMacro = exports.mkMacroArg = exports.mkFor = exports.mkIfElse = exports.mkBinary = exports.mkError = exports.mkInclude = exports.mkAlign = exports.mkFill = exports.mkData = exports.mkSetPC = exports.mkInsn = exports.mkLabel = exports.DataSize = exports.mkMember = exports.mkGetCurPC = exports.mkCallFunc = exports.mkExprObject = exports.mkExprArray = exports.mkBinaryOp = exports.mkUnary = exports.mkKwarg = exports.mkIdent = exports.mkScopeQualifiedIdent = exports.mkLiteral = void 0;
;

function mkLiteral(lit, loc) {
  return {
    type: 'literal',
    lit: lit,
    loc: loc
  };
}

exports.mkLiteral = mkLiteral;

function mkScopeQualifiedIdent(path, absolute, loc) {
  return {
    type: 'qualified-ident',
    path: path,
    absolute: absolute,
    loc: loc
  };
}

exports.mkScopeQualifiedIdent = mkScopeQualifiedIdent;

function mkIdent(name, loc) {
  return {
    type: 'ident',
    name: name,
    loc: loc
  };
}

exports.mkIdent = mkIdent;

function mkKwarg(name, value, loc) {
  return {
    type: 'kwarg',
    name: name,
    value: value,
    loc: loc
  };
}

exports.mkKwarg = mkKwarg;

function mkUnary(op, expr, loc) {
  return {
    type: 'unary',
    op: op,
    expr: expr,
    loc: loc
  };
}

exports.mkUnary = mkUnary;

function mkBinaryOp(op, left, right, loc) {
  return {
    type: 'binary',
    op: op,
    left: left,
    right: right,
    loc: loc
  };
}

exports.mkBinaryOp = mkBinaryOp;

function mkExprArray(list, loc) {
  return {
    type: 'array',
    list: list,
    loc: loc
  };
}

exports.mkExprArray = mkExprArray;

function mkExprObject(props, loc) {
  return {
    type: 'object',
    props: props,
    loc: loc
  };
}

exports.mkExprObject = mkExprObject;

function mkCallFunc(callee, args, loc) {
  return {
    type: 'callfunc',
    callee: callee,
    args: args == null ? [] : args,
    loc: loc
  };
}

exports.mkCallFunc = mkCallFunc;

function mkGetCurPC(loc) {
  return {
    type: 'getcurpc',
    loc: loc
  };
}

exports.mkGetCurPC = mkGetCurPC;

function mkMember(object, property, computed, loc) {
  return {
    type: 'member',
    object: object,
    property: property,
    computed: computed,
    loc: loc
  };
}

exports.mkMember = mkMember;
var DataSize;

(function (DataSize) {
  DataSize[DataSize["Byte"] = 0] = "Byte";
  DataSize[DataSize["Word"] = 1] = "Word";
})(DataSize = exports.DataSize || (exports.DataSize = {}));

;

function mkLabel(name, loc) {
  return {
    name: name,
    loc: loc
  };
}

exports.mkLabel = mkLabel;

function mkInsn(insn, loc) {
  return {
    type: 'insn',
    insn: insn,
    loc: loc
  };
}

exports.mkInsn = mkInsn;

function mkSetPC(pc, loc) {
  return {
    type: 'setpc',
    pc: pc,
    loc: loc
  };
}

exports.mkSetPC = mkSetPC;

function mkData(dataSize, values, loc) {
  return {
    type: 'data',
    values: values,
    dataSize: dataSize,
    loc: loc
  };
}

exports.mkData = mkData;

function mkFill(numBytes, fillValue, loc) {
  return {
    type: 'fill',
    numBytes: numBytes,
    fillValue: fillValue,
    loc: loc
  };
}

exports.mkFill = mkFill;

function mkAlign(alignBytes, loc) {
  return {
    type: 'align',
    alignBytes: alignBytes,
    loc: loc
  };
}

exports.mkAlign = mkAlign;

function mkInclude(filename, loc) {
  return {
    type: 'include',
    filename: filename,
    loc: loc
  };
}

exports.mkInclude = mkInclude;

function mkError(error, loc) {
  return {
    type: 'error',
    error: error,
    loc: loc
  };
}

exports.mkError = mkError;

function mkBinary(kwargs, loc) {
  return {
    type: 'binary',
    kwargs: kwargs,
    loc: loc
  };
}

exports.mkBinary = mkBinary;

function mkIfElse(cases, elseBranch, loc) {
  return {
    type: 'if',
    cases: cases,
    elseBranch: elseBranch !== null ? elseBranch : [],
    loc: loc
  };
}

exports.mkIfElse = mkIfElse;

function mkFor(index, list, body, loc) {
  return {
    type: 'for',
    index: index,
    list: list,
    body: body,
    loc: loc
  };
}

exports.mkFor = mkFor;

function mkMacroArg(ident) {
  return {
    ident: ident
  };
}

exports.mkMacroArg = mkMacroArg;

function mkMacro(name, args, body, loc) {
  return {
    type: 'macro',
    name: name,
    args: args == null ? [] : args,
    body: body,
    loc: loc
  };
}

exports.mkMacro = mkMacro;

function mkCallMacro(name, args, loc) {
  return {
    type: 'callmacro',
    name: name,
    args: args == null ? [] : args,
    loc: loc
  };
}

exports.mkCallMacro = mkCallMacro;

function mkLet(name, value, loc) {
  return {
    type: 'let',
    name: name,
    value: value,
    loc: loc
  };
}

exports.mkLet = mkLet;

function mkAssign(name, value, loc) {
  return {
    type: 'assign',
    name: name,
    value: value,
    loc: loc
  };
}

exports.mkAssign = mkAssign;

function mkStmtExpr(expr, loc) {
  return {
    type: 'statement-expr',
    expr: expr,
    loc: loc
  };
}

exports.mkStmtExpr = mkStmtExpr;

function mkLoadPlugin(filename, moduleName, loc) {
  return {
    type: 'load-plugin',
    filename: filename,
    moduleName: moduleName,
    loc: loc
  };
}

exports.mkLoadPlugin = mkLoadPlugin;

function mkFilescope(name, loc) {
  return {
    type: 'filescope',
    name: name,
    loc: loc
  };
}

exports.mkFilescope = mkFilescope;

function mkDeclareSegment(name, kwargs, loc) {
  return {
    type: 'declare-segment',
    name: name,
    kwargs: kwargs,
    loc: loc
  };
}

exports.mkDeclareSegment = mkDeclareSegment;

function mkUseSegment(name, loc) {
  return {
    type: 'use-segment',
    name: name,
    loc: loc
  };
}

exports.mkUseSegment = mkUseSegment;

function mkBreak(loc) {
  return {
    type: 'break',
    loc: loc
  };
}

exports.mkBreak = mkBreak;

function mkAsmLine(label, stmt, scopedStmts, loc) {
  return {
    label: label,
    stmt: stmt,
    scopedStmts: scopedStmts,
    loc: loc
  };
}

exports.mkAsmLine = mkAsmLine;